/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optional_DescriptionInputs */

const en_optional_description = /** @type {(inputs: Optional_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional description`)
};

const es_optional_description = /** @type {(inputs: Optional_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripcion opcional`)
};

/**
* | output |
* | --- |
* | "Optional description" |
*
* @param {Optional_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const optional_description = /** @type {((inputs?: Optional_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optional_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_optional_description(inputs)
	return es_optional_description(inputs)
});